import React, { useEffect, useRef, useState } from 'react';
import mermaid from 'mermaid';
import './MermaidDiagram.css';

function MermaidDiagram({ diagram, title, description }) {
  const mermaidRef = useRef(null);
  const [error, setError] = useState(null);
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    // Initialize mermaid once
    if (!isInitialized) {
      try {
        mermaid.initialize({ 
          startOnLoad: false,
          theme: 'default',
          securityLevel: 'loose',
          fontFamily: 'inherit',
        });
        setIsInitialized(true);
      } catch (err) {
        console.error('Mermaid initialization error:', err);
        setError(err.message);
      }
    }
  }, [isInitialized]);

  useEffect(() => {
    if (!diagram || !mermaidRef.current || !isInitialized) return;

    const renderDiagram = async () => {
      try {
        // Clear previous content
        mermaidRef.current.innerHTML = '';

        // Create a unique ID for this diagram
        const id = `mermaid-${Math.random().toString(36).substr(2, 9)}`;

        // Use mermaid.run() instead of render() for better compatibility
        const { svg } = await mermaid.render(id, diagram);
        if (mermaidRef.current) {
          mermaidRef.current.innerHTML = svg;
          setError(null);
        }
      } catch (err) {
        console.error('Mermaid rendering error:', err);
        setError(err.message);
        if (mermaidRef.current) {
          mermaidRef.current.innerHTML = `<div class="mermaid-error">Error rendering diagram: ${err.message}</div>`;
        }
      }
    };

    renderDiagram();
  }, [diagram, isInitialized]);

  if (!diagram) {
    return null;
  }

  return (
    <div className="mermaid-diagram-container">
      {title && <h6 className="mermaid-title">{title}</h6>}
      {description && <p className="mermaid-description">{description}</p>}
      {error && (
        <div className="mermaid-error" style={{ color: 'red', padding: '10px' }}>
          Error rendering diagram: {error}
        </div>
      )}
      <div ref={mermaidRef} className="mermaid-content"></div>
    </div>
  );
}

export default MermaidDiagram;

